import React from 'react';
import { Mail } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/5 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-primary/10 rounded-full blur-[120px] animate-pulse delay-700" />
      
      <div className="relative flex flex-col items-center gap-8">
        {/* Animated Logo Container */}
        <div className="relative group">
          {/* Glow Effect */}
          <div className="absolute inset-0 bg-primary/30 rounded-3xl blur-2xl group-hover:bg-primary/40 transition-all duration-1000 animate-pulse" />
          
          <div className="relative flex h-24 w-24 items-center justify-center rounded-[2rem] bg-primary shadow-2xl shadow-primary/40 border border-primary/20 animate-bounce-subtle">
            <Mail className="h-10 w-10 text-primary-foreground animate-in fade-in zoom-in duration-1000" />
          </div>
        </div>

        {/* Text and Spinner */}
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="flex items-center gap-3">
             <div className="w-4 h-4 rounded-full border-2 border-primary/30 border-t-primary animate-spin" />
             <h2 className="text-xl font-black tracking-tighter text-foreground bg-clip-text text-transparent bg-gradient-to-r from-foreground to-foreground/60">
                Mailwise
             </h2>
          </div>
          
          <div className="flex flex-col gap-1">
             <p className="text-sm font-bold text-muted-foreground uppercase tracking-[0.3em] opacity-40 animate-pulse">
                Orchestrating your workspace
             </p>
             <div className="w-full h-1 bg-muted/30 rounded-full overflow-hidden mt-2">
                <div className="h-full bg-primary animate-loading-bar rounded-full shadow-[0_0_8px_rgba(var(--primary),0.5)]" />
             </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes bounce-subtle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-bounce-subtle {
          animation: bounce-subtle 3s ease-in-out infinite;
        }
        @keyframes loading-bar {
          0% { width: 0%; transform: translateX(-100%); }
          50% { width: 70%; transform: translateX(20%); }
          100% { width: 100%; transform: translateX(200%); }
        }
        .animate-loading-bar {
          animation: loading-bar 2s cubic-bezier(0.65, 0, 0.35, 1) infinite;
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
